/**
 * One of the three questions Arrange asks, numbered and named: the score, its players, and
 * anything else.
 *
 * The number is the order they are answered in, and it is all the instruction the screen
 * gives: there is nothing on it but these three and the button under them.
 */

import type { ReactNode } from "react";

export interface ArrangeStepProps {
  readonly number: number;
  readonly title: string;
  /** Said quietly beside the title, as "optional" is. */
  readonly aside?: string;
  /** The field the title names, where the step is one field. */
  readonly htmlFor?: string;
  readonly children: ReactNode;
}

const TITLE = "text-[15px] font-semibold text-shell-lit";

export default function ArrangeStep({
  number,
  title,
  aside,
  htmlFor,
  children,
}: ArrangeStepProps): JSX.Element {
  return (
    <section className="flex flex-col gap-2.5">
      <div className="flex items-baseline gap-2.5">
        <span aria-hidden="true" className="font-mono text-[12px] text-shell-dim">
          {number}
        </span>
        {htmlFor === undefined ? (
          <h2 className={TITLE}>{title}</h2>
        ) : (
          <label htmlFor={htmlFor} className={TITLE}>
            {title}
          </label>
        )}
        {aside === undefined ? null : <span className="text-[12px] text-shell-text">{aside}</span>}
      </div>
      {children}
    </section>
  );
}
